export default class VideoNav {
    static init(): void {
        this.videoNavFixed();
        this.videoNavActiveScroll();
        this.videoNavMobile();
    }

    private static videoNavFixed(): void {
        const container = document.querySelector('.js-video-nav-container') as HTMLElement;
        const videoNav = document.querySelector('.js-video-nav') as HTMLElement;
        const videoSection = document.querySelector('.video-section__inner') as HTMLElement;

        if (!container || !videoNav || !videoSection) return;

        const placeholder = document.createElement('div');
        placeholder.style.display = 'none';
        videoNav.parentNode?.insertBefore(placeholder, videoNav);

        const handleScroll = () => {
            const containerRect = container.getBoundingClientRect();
            const sectionRect = videoSection.getBoundingClientRect();
            const navHeight = videoNav.offsetHeight;

            if (containerRect.top <= 0 && containerRect.bottom > navHeight) {
                videoNav.classList.remove('is-bottom');
                videoNav.classList.add('is-fixed');
                videoNav.style.width = sectionRect.width + 'px';
                videoNav.style.left = sectionRect.left + 'px';
                placeholder.style.display = 'block';
                placeholder.style.height = navHeight + 'px';
            } else if (containerRect.bottom <= navHeight) {
                videoNav.classList.remove('is-fixed');
                videoNav.classList.add('is-bottom');
                videoNav.style.width = '';
                videoNav.style.left = '';
                placeholder.style.display = 'block';
                placeholder.style.height = navHeight + 'px';
            } else {
                videoNav.classList.remove('is-fixed', 'is-bottom');
                videoNav.style.width = '';
                videoNav.style.left = '';
                placeholder.style.display = 'none';
            }
        };

        window.addEventListener('scroll', handleScroll);
        window.addEventListener('resize', handleScroll);
        handleScroll();
    }

    private static videoNavActiveScroll(): void {
        const navItems = document.querySelectorAll('.video-nav__item');
        const sectionItems = document.querySelectorAll('.video-section__item');

        if (!navItems.length || !sectionItems.length) return;

        navItems.forEach((navItem) => {
            navItem.addEventListener('click', (e) => {
                e.preventDefault();
                const anchor = navItem.getAttribute('data-video-anchor');
                const targetSection = document.querySelector(`[data-video-id="${anchor}"]`) as HTMLElement;

                if (targetSection) {
                    const navElement = document.querySelector('.js-video-nav') as HTMLElement;
                    const navHeight = navElement?.offsetHeight || 0;
                    const offset = targetSection.offsetTop - navHeight;
                    window.scrollTo({ top: offset, behavior: 'smooth' });
                }
            });
        });

        const handleScroll = () => {
            const navElement = document.querySelector('.js-video-nav') as HTMLElement;
            const navHeight = navElement?.offsetHeight || 0;
            const scrollPosition = window.scrollY + navHeight + 50;

            let currentSection = '';

            sectionItems.forEach((section) => {
                const sectionElement = section as HTMLElement;
                const sectionTop = sectionElement.offsetTop;
                const sectionHeight = sectionElement.offsetHeight;

                if (scrollPosition >= sectionTop && scrollPosition < sectionTop + sectionHeight) {
                    currentSection = sectionElement.getAttribute('data-video-id') || '';
                }
            });

            navItems.forEach((item) => item.classList.remove('is-active'));

            if (currentSection) {
                const activeNavItem = document.querySelector(`[data-video-anchor="${currentSection}"]`);
                if (activeNavItem) {
                    activeNavItem.classList.add('is-active');
                }
            }
        };

        window.addEventListener('scroll', handleScroll);
        handleScroll();
    }

    private static videoNavMobile(): void {
        const isMobile = () => window.innerWidth < 992;

        const trigger = document.querySelector('.video-section-mobile__trigger') as HTMLElement;
        const videoSection = document.querySelector('.video-section') as HTMLElement;
        const mobileNav = document.querySelector('.video-nav-mobile') as HTMLElement;
        const closer = document.querySelector('.video-nav-mobile__closer') as HTMLElement;
        const mobileNavItems = document.querySelectorAll('.video-nav-mobile__item');

        if (!trigger || !videoSection || !mobileNav || !closer) return;

        let observer: IntersectionObserver | null = null;

        const initObserver = () => {
            if (observer) {
                observer.disconnect();
            }

            if (isMobile()) {
                observer = new IntersectionObserver(
                    (entries) => {
                        entries.forEach((entry) => {
                            if (entry.isIntersecting) {
                                trigger.classList.add('is-visible');
                            } else {
                                trigger.classList.remove('is-visible');
                            }
                        });
                    },
                    {
                        threshold: 0.1,
                    },
                );

                observer.observe(videoSection);
            }
        };

        initObserver();

        trigger.addEventListener('click', () => {
            mobileNav.classList.add('is-open');
            document.body.classList.add('overlay-is-active');
        });

        closer.addEventListener('click', () => {
            mobileNav.classList.remove('is-open');
            document.body.classList.remove('overlay-is-active');
        });

        mobileNavItems.forEach((item) => {
            item.addEventListener('click', (e) => {
                e.preventDefault();
                const anchor = item.getAttribute('data-video-mobile-anchor');
                const targetSection = document.querySelector(`[data-video-id="${anchor}"]`) as HTMLElement;

                mobileNav.classList.remove('is-open');
                document.body.classList.remove('overlay-is-active');

                if (targetSection) {
                    setTimeout(() => {
                        const navElement = document.querySelector('.js-video-nav') as HTMLElement;
                        const navHeight = navElement?.offsetHeight || 0;
                        const offset = targetSection.offsetTop - navHeight;
                        window.scrollTo({ top: offset, behavior: 'smooth' });
                    }, 200);
                }
            });
        });

        let resizeTimeout: number;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = window.setTimeout(() => {
                if (!isMobile()) {
                    trigger.classList.remove('is-visible');
                    mobileNav.classList.remove('is-open');
                    document.body.classList.remove('overlay-is-active');
                    if (observer) {
                        observer.disconnect();
                    }
                } else {
                    initObserver();
                }
            }, 150);
        });
    }
}
